import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
import { Link } from '@inertiajs/inertia-vue3';

import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  components: {
    Head: Head,
    Link: Link
  },
  layout: Layout,
  props: {
    resourceTypes: {
      type: Object,
      "default": {}
    },
    managerList: {
      type: Array,
      "default": []
    },
    userType: {
      type: String,
      "default": "employee"
    }
  },
  data: function data() {
    return {
      resourceList: [],
      isLoadingMapping: true,
      isLoadingPaginate: true,
      currentPage: 1,
      searchValue: "",
      totalCount: 0,
      mappingStatus: true,
      reportingTo: ""
    };
  },
  mounted: function mounted() {
    this.getUserList(true);
  },
  methods: {
    getUserList: function getUserList() {
      var _arguments = arguments,
        _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var resetPaginate, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resetPaginate = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                if (resetPaginate) {
                  _this.isLoadingPaginate = true;
                  _this.currentPage = 1;
                }
                _this.isLoadingMapping = true;
                _context.next = 5;
                return axios.post('/user_management/get_mapping', {
                  page: _this.currentPage,
                  search: _this.searchValue,
                  mappingStatus: _this.mappingStatus,
                  reportingTo: _this.reportingTo
                });
              case 5:
                res = _context.sent;
                if (res.data.status == 'success') {
                  _this.resourceList = res.data.userList;
                  _this.totalCount = res.data.userCount;
                }
                _this.isLoadingMapping = false;
                _this.isLoadingPaginate = false;
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    pageChange: function pageChange(current_page) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.currentPage = current_page;
                _context2.next = 3;
                return _this2.getUserList();
              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    searchName: function searchName() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getUserList(true);
              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    saveData: function saveData(userData) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (userData.title) {
                  _context4.next = 3;
                  break;
                }
                ElMessage({
                  showClose: true,
                  message: 'Please select a title.',
                  type: 'error'
                });
                return _context4.abrupt("return", true);
              case 3:
                _this4.$store.loading = true;
                _context4.next = 6;
                return axios.post('/user_management/store_mapping', userData);
              case 6:
                res = _context4.sent;
                ElMessage({
                  showClose: true,
                  message: res.data.msg,
                  type: res.data.status
                });
                _this4.$store.loading = false;
                if (!_this4.hideMapped) {
                  _context4.next = 12;
                  break;
                }
                _context4.next = 12;
                return _this4.getUserList(true);
              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};